import styled, { keyframes } from "styled-components";
import { paletas } from "../../../../styles/theme";

const animacao = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  animation: 0.25s ${animacao};
  display: flex;
  flex-direction: column;
  font-size: 20px;

  h3,
  h4,
  p,
  span {
    font-size: 1rem;
    font-weight: 500;
    font-family: "Bebas Neue", cursive;
    font-family: "Open Sans", sans-serif;
    font-family: "Poppins", sans-serif;
  }

  .content {
    flex: 1;
  }

  .headerInterno {
    text-align: center;

    h3 {
      margin-bottom: 20px;
      line-height: 2rem;
    }

    h5 {
      margin: 10px 0 30px;
    }
  }

  .botaoIniciar {
    margin: 40px auto;
  }

  .tabelaTorneio {
    h5 {
      margin: 5px 0 15px;
    }
    p {
      text-align: left;
      font-size: 16px;
    }
    span {
      font-size: 12px;
    }
    svg {
      color: ${paletas.DarkOrange};
    }
  }
`;
